module.exports = __webpack_public_path__ + "static/media/at-mock-2.b3cdf12e.png";